<template>
  <div class="reservation-container">
    <h3>{{ t.reservation_thanks }}</h3>
    <div class="inner-container">
      <div class="text-container">
        <p>{{ t.reservation_thanks_text }}</p>
      </div>
      <div class="image-container">
        <img :src="terreinImage" alt="Terrein">
      </div>
    </div>
  </div>
</template>

<script>
import TerreinImage from '@/assets/terrein.png'
import {ref} from "vue";
import useTexts from "@/composables/useTexts";

export default {
  name: 'ReservationConfirmation',
  setup() {
    const terreinImage = ref(TerreinImage);
    const { getTextsForComponent } = useTexts();
    const t = getTextsForComponent('ReservationConfirmation')

    return {
      terreinImage,
      t
    };
  },
}
</script>

<style scoped>
.reservation-container {
  background-color: #e9e9e9;
  padding: 20px;
  border-radius: 5px;
  max-width: 800px;
  margin: 0 auto;
}

h3 {
  margin-bottom: 20px;
}

.inner-container {
  display: flex;
  flex-direction: row;
  background-color: #FFFFFF;
  padding: 20px;
  border-radius: 5px;
}

.text-container {
  flex: 1;
  padding-right: 20px;
}

.image-container {
  flex: 1;
}

.image-container img {
  width: 100%;
  height: auto;
}
</style>
